"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * Data transfer object for agency quality evaluation report
 *
 * @author VBr
 */


var AgencyQualityEvaluationDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(AgencyQualityEvaluationDTO, _DomainObject_1$Domai);

  /**
   *
   * @param dataUploadId id of agency data upload
   * @param competitorSiteId id of competitor site
   * @param totalCollectedProducts number of total collected products
   * @param totalCollectedPrices number of total collected prices
   * @param outliers number of outliers
   * @param date when were price collected
   */
  function AgencyQualityEvaluationDTO(dataUploadId, competitorSiteId, outliers, totalCollectedProducts, totalCollectedPrices, date) {
    var _this;

    _classCallCheck(this, AgencyQualityEvaluationDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AgencyQualityEvaluationDTO).call(this));
    _this.dataUploadId = dataUploadId;
    _this.competitorSiteId = competitorSiteId;
    _this.outliers = outliers;
    _this.totalCollectedProducts = totalCollectedProducts;
    _this.totalCollectedPrices = totalCollectedPrices;
    _this.date = date;
    return _this;
  }

  return AgencyQualityEvaluationDTO;
}(DomainObject_1.DomainObject);

exports.AgencyQualityEvaluationDTO = AgencyQualityEvaluationDTO;

AgencyQualityEvaluationDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(AgencyQualityEvaluationDTO.name);
  return {
    dataUploadId: builder.str('internalProductId'),
    competitorSiteId: builder.str('competitorSiteId'),
    outliers: builder.num('outliers'),
    totalCollectedProducts: builder.num('totalCollectedProducts'),
    totalCollectedPrices: builder.num('totalCollectedPrices'),
    date: builder.date('date')
  };
}();